import styled from 'styled-components';
import { Fab } from '@mui/material';
import { deviceSizes } from '../../../../config/devices';
export var SliderContainer = styled.div.withConfig({
  displayName: "style__SliderContainer",
  componentId: "sc-1odemgt-0"
})(["padding:0 4rem;width:100%;border-radius:6px;position:relative;@media (max-width:", "){padding:0;padding-top:2rem;}.react-multi-carousel-list{position:static;}.react-multi-carousel-item{margin:10px;width:180px !important;img{border-radius:6px;}}.active{border:2px solid ", ";filter:drop-shadow(0px 2px 4px rgba(0,0,0,0.14)) drop-shadow(0px 4px 5px rgba(0,0,0,0.12)) drop-shadow(0px 1px 10px rgba(0,0,0,0.2));}"], deviceSizes.mobileL, function (_ref) {
  var theme = _ref.theme;
  return theme.primary.main;
});
export var VideoContainer = styled.div.withConfig({
  displayName: "style__VideoContainer",
  componentId: "sc-1odemgt-1"
})(["width:100%;height:350px;margin-bottom:20px;div{padding:0 !important;margin:0 !important;display:block !important;iframe{width:100% !important;height:350px !important;}}"]);
export var StyledLeftButton = styled(Fab).withConfig({
  displayName: "style__StyledLeftButton",
  componentId: "sc-1odemgt-2"
})(["&&{position:absolute;left:0;background-color:white;box-shadow:none;@media (max-width:", "){display:none;}}"], deviceSizes.mobileL);
export var StyledRightButton = styled(Fab).withConfig({
  displayName: "style__StyledRightButton",
  componentId: "sc-1odemgt-3"
})(["&&{position:absolute;right:0;background-color:white;box-shadow:none;@media (max-width:", "){display:none;}}"], deviceSizes.mobileL);